// Happy Energy CRM – das Büro am Laptop (crm.…). Seit E1: Anmeldung, die
// Leute mit ihren Einladungen, die Geräteliste. Seit E3: je Rolle eine
// eigene Sicht, die Übersicht, „Zu prüfen“ und die Freigabe mit dem
// Material (Crm.tsx).

import { Anmeldung, appStarten } from "@happy-energy/oberflaeche";
import { Crm } from "./Crm.tsx";

appStarten(
  "crm",
  <Anmeldung app="crm" appName="Happy Energy CRM">
    {(ich, hilfen) => <Crm ich={ich} hilfen={hilfen} />}
  </Anmeldung>,
);
